import { render, staticRenderFns } from "./CheckForDupsBlock.vue?vue&type=template&id=95408258&scoped=true"
import script from "./CheckForDupsBlock.vue?vue&type=script&lang=js"
export * from "./CheckForDupsBlock.vue?vue&type=script&lang=js"
import style0 from "./CheckForDupsBlock.vue?vue&type=style&index=0&id=95408258&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95408258",
  null
  
)

export default component.exports